import React, { Component } from 'react';

export default class Timer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: false
    };
  }

componentDidMount() {
  this.myInterval = setInterval(() => {
    const { enDate } = this.props;

    if (!enDate || isNaN(enDate)) {
      clearInterval(this.myInterval);
      this.setState({ expired: true });
      return;
    }

    const now = Date.now();
    const distance = enDate - now;

    if (distance <= 0) {
      clearInterval(this.myInterval);
      this.setState({ expired: true });
    } else {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.setState({ days, hours, minutes, seconds });
    }
  }, 1000);
}

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  render() {
    const { days, hours, minutes, seconds, expired } = this.state;
    const { nbrdays, infoSource, messageWelcome, message} = this.props;

    const timerShow = () => (
      <div>
        <table style={{ textAlign: 'center', width: '100%' }}>
          <thead>
            <tr>
              <th><h1>{String(days).padStart(2, '0')}</h1></th>
              <th><h1>{String(hours).padStart(2, '0')}</h1></th>
              <th><h1>{String(minutes).padStart(2, '0')}</h1></th>
              <th><h1>{String(seconds).padStart(2, '0')}</h1></th>
            </tr>
            <tr>
              <td><h5>{infoSource.language(infoSource, "title", "days")}</h5></td>
              <td><h5>{infoSource.language(infoSource, "title", "hours")}</h5></td>
              <td><h5>{infoSource.language(infoSource, "title", "minutes")}</h5></td>
              <td><h5>{infoSource.language(infoSource, "title", "seconds")}</h5></td>
            </tr>
          </thead>
        </table>
        <h2>{infoSource.language(infoSource, "title", "timeRemaining")}</h2>
      </div>
    );

    const renderContent = () => {
  if (expired  && messageWelcome) {
        return  <div
        className='d-flex align-items-center justify-content-center'
        style={{
          background: 'LightBlue',
          padding: '20px',
          borderRadius: '8px'
        }}>
            <h1>{message.accountTitle}</h1>
        </div>;
      }
      if ((expired || nbrdays <= 0)) {
        return  <div
        className='d-flex align-items-center justify-content-center'
        style={{
          background: expired || nbrdays <= 0 ? 'Beige' : 'LightBlue',
          padding: '20px',
          borderRadius: '8px'
        }}>
          <h1>{infoSource.language(infoSource, "title", "compExp")}</h1>
        </div>;
      }
      return <div
        className='d-flex align-items-center justify-content-center'
        style={{
          background: 'LightBlue',
          padding: '20px',
          borderRadius: '8px'
        }}>
          {timerShow()};
         </div>
    };

    

    return ( renderContent());
  }
}